import { render, staticRenderFns } from "./CarTableArchive.vue?vue&type=template&id=5f442c4d&scoped=true"
import script from "./CarTableArchive.vue?vue&type=script&lang=ts"
export * from "./CarTableArchive.vue?vue&type=script&lang=ts"
import style0 from "./CarTableArchive.vue?vue&type=style&index=0&id=5f442c4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f442c4d",
  null
  
)

export default component.exports